import EventType from './EventType';

export default EventType;
